<template>
        <div class="referential-list">
            <div 
                v-for="referential in filteredSortedReferentials" 
                :key="referential.referentiel_id" 
                class="referential-item"
                :class="{ locked: lockedClass(referential.referentiel_id) }"
                :title="referentialStatus(referential.referentiel_id).LOCKED ? 'Verrouillé jusqu\'à ' + formatDate(referential.locked_until) + ' par ' + referential.modified_by : ''"
            >
                <!-- <div class="id-col">{{ referential }}</div> -->
                <div class="title-col">{{ referential.title }}</div>
                <div class="description-col" :title="referential.site">{{referential.description }}</div>
                <!-- <div class="projects-col" v-if="selectedReferential > 0 && getProjectsAfterValidation + getProjectsInValidation > 0" @click.stop="goToProjectValidators">
                    <span class="projects-name">Projet(s)</span>
                    <div v-if="getProjectsInValidation" class="validation"> {{ getProjectsInValidation }} en validation</div>
                    <div v-if="getProjectsAfterValidation" class="validation"> {{ getProjectsAfterValidation }} validé(s) ou archivé(s)</div>
                </div> -->
                <div class="actions-col" v-if="selectedReferential > 0">
                    <button @click.stop="unlockReferential()" v-if="referential.status !== 'RELEASEUSED' && referential.status != 'ARCHIVE' && (referentialStatus(referential.referentiel_id).LOCKED || referentialStatus(referential.referentiel_id).LOCKED === null) && referentialStatus(referential.referentiel_id).OWNER" class="btn btn-icon"><i class="bi bi-unlock" title="Débloquer référentiel"></i></button>
                    <button @click.stop="addChild()" v-if=" referential.status != 'RELEASEUSED' && referential.status != 'ARCHIVE' && !isReferentialLocked(selectedReferential) && !referentialStatus(referential.referentiel_id).READONLY" class="btn btn-icon"><i class="bi bi-plus" title="Créer critère"></i></button>
                    <button @click.stop="editReferential()" v-if=" referential.status != 'RELEASEUSED' && referential.status != 'ARCHIVE' &&  !isReferentialLocked(selectedReferential) && !referentialStatus(referential.referentiel_id).READONLY " class="btn btn-icon"><i class="bi bi-pencil" title="Editer"></i></button>
                    <button @click.stop="deleteReferentialTemp(referential)" class="btn btn-icon" v-if="isAdmin && referential.status === 'ARCHIVE'"><i class="bi bi-trash3-fill" title="Effacer"></i></button>
                    <button v-if="(referentialStatus(referential.referentiel_id).FORCED || !isReferentialLocked(referential.referentiel_id)) && ( isAdmin || referential.RC ) && referential.status != 'ARCHIVE'" @click.prevent="changeReferentialStatus('ARCHIVE')" class="btn btn-icon"><i class="bi bi-trash3-fill" title="Archiver"></i></button>
                    <button @click.stop="duplicateReferential()" class="btn btn-icon" v-if="isAdmin"><i class="bi bi-copy" title="Dupliquer"></i></button>
                    <button @click.stop="createProject()" class="btn btn-icon"><i class="bi bi-folder-plus" title="Créer projet à partir du referentiel"></i></button>
                    <button @click.stop="openPDF(referential)" class="btn btn-icon"><i class="bi bi-filetype-pdf" title="Génération de pdf"></i></button>
                    <button @click.stop="analyzeReferential()" v-if="!referentialStatus(referential.referentiel_id).READONLY" class="btn btn-icon"><i class="bi bi-exclamation-circle" title="Analyse du référentiel"></i></button>
                    <button v-if="selectedReferential > 0" @click="exitReferentialView" class="back-button">Retour</button>
                    <div v-if="selectedReferential>0 && !isReferentialLocked(selectedReferential)">
                        <!-- <button v-if="referential.status === 'EDITING'" @click.prevent="changeReferentialStatus('VALIDATION')" class="create-button">Mise en évaluation</button> -->
                        <!-- <button v-if="referential.status === 'RELEASE'" @click.prevent="changeReferentialStatus('ARCHIVE')" class="create-button">Archiver</button> -->
                        <button v-if="referential.status === 'RELEASE' && referential.status !== 'RELEASEUSED' && (/* getProjectsAfterValidation +  */getProjectsInValidationList.length <= 0)" @click.prevent="changeReferentialStatus('EDITING')" class="create-button">Remise en édition</button>
                        <button v-if="referential.status === 'EDITING' && selectedReferential > 0" @click.prevent="changeReferentialStatus('RELEASE')" class="create-button">Mise en production</button>
                        <button v-if="referential.status === 'ARCHIVE' && selectedReferential > 0" @click.prevent="changeReferentialStatus('EDITING')" class="create-button">Retour en édition</button>
                    </div>
                </div>
            </div>
        </div>
        
      <!--   <div v-if="selectedReferential" class="criteria-container">
            <ReferentialTreeEditor 
                v-bind:children="fetchRootCriteria(selectedReferential)" 
                v-bind:level=0
                :filter-is-active="filterIsActive">
            </ReferentialTreeEditor>
        </div> -->
        <ConfirmationDialog v-if="canEditList.confirmationDialogOpen" />
        <ReferentialModalCreator v-if="canEditList.referentialCreatorOpen"/>
        <CriteriaModalEditor v-if="selectedReferential > 0 && canEditList.criteriaEditorOpen"/>
        <QuestionModalEditor v-if="selectedReferential > 0 && canEditList.questionEditorOpen" :key="activeQuestion ? activeQuestion.id : 'new-question'"/>
        <ProjectModalCreator v-if="canEditList.projectModalOpen"/>
        <LoadingOverlay v-if="loading"/>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
/* import ReferentialTreeEditor from './ReferentialTreeEditor.vue' */
import ReferentialModalCreator from '../admin/ReferentialModalCreator.vue'
import CriteriaModalEditor from '../admin/CriteriaModalEditor.vue';
import QuestionModalEditor from '../admin/QuestionModalEditor.vue';
import ConfirmationDialog from './ConfirmationDialog.vue';
import ProjectModalCreator from '../project/ProjectModalCreator.vue';
import '../../assets/styles/base.css';
import '../../assets/styles/multiselect.css';
import LoadingOverlay from './LoadingOverlay.vue';
export default {
    name: "ReferentialHeader",

    components: {
        /* ReferentialTreeEditor, */
        ReferentialModalCreator,
        CriteriaModalEditor,
        QuestionModalEditor,
        ConfirmationDialog,
        ProjectModalCreator,
        LoadingOverlay
    },
    data() {
        return {
            filters: {
                title: "",
                status: "",
                reference: ""
            },
            statusOptions:[
                {value:"", label:"Statut"},
                {value:"EDITING", label:"Edition"},
                {value:"RELEASE", label:"Production"},
                {value:"RELEASEUSED", label: "Production (utilisé)"},
                // {value:"ARCHIVE", label:"Archivé"}
            ],
            sortField: "id",
            sortDirection: "asc",
            showFilters: false,
           /*  showArchived: false, */
            referentialLoading: true,
        }
    },
    computed: {
        ...mapState("referential", ["referentialData", "selectedReferential", "canEditList", "loading","numberProjects", "activeQuestion", "referentialErrors", "unlockStatus", "projectStatusByReferential", "pdf"]),
        ...mapState("project", ["projectData", "roles"]),
        ...mapState("auth", ["user_id", "isAdmin"]),
        ...mapGetters("referential", ["fetchRootCriteria", "isReferentialLocked", "getReferentialStatus", "formatDate", "referentialLoaded", /* "getProjectsAfterValidation", */ "getProjectsInValidationList", "getProjectsAfterValidationList", "lockedClass"]),

        readyToFetchProjectStatus() {
            return this.isAdmin && this.selectedReferential > 0;
        },

        baseFilteredReferentialData() {
            return this.referentialData.filter(
                ref => this.selectedReferential === 0 || this.selectedReferential == ref.referentiel_id
            );
        },
        
        filteredSortedReferentials() {
            let filtered = this.baseFilteredReferentialData;
            
        /*     if(this.showArchived) {
                filtered = filtered.filter(ref => ref.status === 'ARCHIVE');
            } else {
                filtered = filtered.filter(ref => ref.status !== 'ARCHIVE');
            }
 */
            if (this.filters.title) {
                filtered = filtered.filter(ref => 
                    ref.title.toLowerCase().includes(this.filters.title.toLowerCase())
                );
            }
            
            if (this.filters.status) {
                filtered = filtered.filter(ref => 
                    ref.status === this.filters.status
                );
            }
                
            return [...filtered].sort((a, b) => {
                switch (this.sortField) {
                    case "id":
                        return this.sortDirection === "asc" 
                            ? a.referentiel_id - b.referentiel_id
                            : b.referentiel_id - a.referentiel_id;
                    case "title":
                        return this.sortDirection === "asc"
                            ? a.title.localeCompare(b.title)
                            : b.title.localeCompare(a.title);
                    case "status":
                        return this.sortDirection === "asc"
                            ? a.status.localeCompare(b.status)
                            : b.status.localeCompare(a.status);
                    case "modification_date":
                        return this.sortDirection === "asc"
                            ? new Date(a.modification_date) - new Date(b.modification_date)
                            : new Date(b.modification_date) - new Date(a.modification_date);
                    case "creation_date":
                        return this.sortDirection === "asc"
                            ? new Date(a.creation_date) - new Date(b.creation_date)
                            : new Date(b.creation_date) - new Date(a.creation_date);
                    default:
                        return a.referentiel_id - b.referentiel_id;
                }
            });
        }
    },
    async mounted() {
        this.referentialLoading = true
        await this.$store.dispatch("referential/fetchReferentialList")
            .catch(error => console.error("Error fetching referential data:", error))
        this.$store.dispatch("referential/projectStatus", {id: this.$route.params.id})
        this.checkRouteParams()
        this.referentialLoading = false
        // this.nowDate()
        
    },
    watch: {
        '$route.params.id': 'checkRouteParams',

        /* isAdmin(newVal, oldVal) {
            //console.log("old val, temporary to check if isAdmin", oldVal)
            if (newVal && this.$route.params.id) {
                this.$store.dispatch("referential/projectStatus", { id: this.$route.params.id });
            }
        }, */
        readyToFetchProjectStatus: {
            handler(isReady) {
                if (isReady) {
                    //console.log(`[Header] Conditions remplies, récupération des statuts pour le référentiel ${this.selectedReferential}`);
                    this.$store.dispatch("referential/projectStatus", { id: this.selectedReferential });
                }
            },
            immediate: true // Très important : vérifie la condition dès le chargement.
        },
        selectedReferential() {
        this.$store.commit('referential/unlockStatus', false);
        }
    },
    methods: {
        async openPDF(referential){
        if(!referential)return;
            const id = this.selectedReferential
            const pdfBlob = await this.$store.dispatch("referential/createReportPDF", id)
            //console.log("pdfBlob : ",pdfBlob)
            //const correctedImage = new Blob([pdfBlob]);
            //console.log("correctedImage ",correctedImage)
        if (pdfBlob && pdfBlob.size > 0) {
            const imageURL = URL.createObjectURL(pdfBlob);
            window.open(imageURL, '_blank_');
        } else {
            console.error("Failed to create PDF or received an empty blob.");
        }
      },
        /* checkDeleteAuthorization(referential){
            //console.log(referential)
        }, */
        AmountOfProject(referentialId){
            if (!this.projectData || this.projectData.length === 0) {
                return 0;
            }
            return this.projectData.filter(project => project.referential_id === referentialId).length;
        },

        sortBy(field) {
            if (this.sortField === field) {
                // Inverser la direction du tri si on clique sur le même champ
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                // Nouveau champ de tri, par défaut ascendant
                this.sortField = field;
                this.sortDirection = 'asc';
            }
        },
        checkRouteParams() {
            //console.log("Route params found, setting selectedReferential to:", this.$route)
            if(this.$route.params.id) {
                //console.log("Route params found, setting selectedReferential to:", this.$route.params.id)
                this.$store.dispatch("referential/fetchCriteriaListFromReferential", { id: this.$route.params.id})
                //console.log("Is it an admin user?", this.isAdmin)
                //Unnecessary ?
                this.$store.dispatch("referential/fetchReferentialList")
                if(this.isAdmin){
                    //console.log("Admin user, fetching referentials")
                    this.$store.dispatch("referential/projectStatus", {id: this.$route.params.id})
                }
            } else if(this.$route.params.referentialId) {   
                // because there were issues where it was reset. I could not get to the page anymore
                //console.log("Route params found, setting selectedReferential to:", this.$route.params.referentialId)
                this.$store.dispatch("referential/fetchCriteriaListFromReferential", { id: this.$route.params.referentialId})
                //console.log("Is it an admin user?", this.isAdmin)
                //Unnecessary ?
                if(this.isAdmin){
                    //console.log("Admin user, fetching referentials")
                    this.$store.dispatch("referential/fetchReferentialList")
                    this.$store.dispatch("referential/projectStatus", {id: this.$route.params.id})
                }
            } else {
                //console.log("No referentialId in route params, resetting selectedReferential to 0")
                //console.log("Selected referential before reset:", this.selectedReferential)
                //console.log("but not really, rechecking route", this.$route)
                //console.log("and further in: ", this.$route.params)
                //console.log("and further in: ", this.$route.params.referentialId)
                // this.$store.commit("referential/selectTreeMutation", 0)
            }   
        },

         async changeReferentialStatus(status) {
            if(this.selectedReferential<0)return;
            //console.log("status :", status, "\nthis.releaseStatus :", this.releaseStatus)
            //console.log(status, ": staturs")
            await this.$store.dispatch("referential/referentialValidate", {
                id: this.selectedReferential
            })
            let title = ""
            let message = ""
            let hasErrors = this.referentialErrors && this.referentialErrors.length > 0;
            if (hasErrors) {
                    title = "Le référentiel a des problèmes :";
                    for (const error of this.referentialErrors) {
                            message += `<b>Status:</b> ${error.status}<br>`;
                            message += `<b class="parameters">Paramètre:</b> ${error.parameter}<br>`;
                            message += `<b>Message:</b> ${error.message}<br><br>`;
                        }
                        //console.log(status, ": staturs1")
                        this.$store.commit("referential/returnConfirmationObjectMutation", { 
                            id: this.selectedReferential, 
                            type: "referential-change-status",
                            title: title,
                            message: message,
                            newStatus: status,
                            //hasBlockingError: hasBlockingError,
                            status: this.releaseStatus,
                        });
                        return;
                    }

                    switch (status) {
                    case "RELEASE":
                        title = "Mise en production";
                        message = "Êtes-vous sûr de vouloir mettre ce référentiel en production ?";
                    break;
                    case "ARCHIVE":
                        title = "Archiver"
                        message = "Êtes-vous sûr de vouloir archiver ce référentiel ?"
                        break;
                    default:
                        title = "Remise en édition"
                        message = "Êtes-vous sûr de vouloir remettre ce référentiel en édition ?"
                        break;
                }
                //console.log(status, ": staturs2")
            this.$store.commit("referential/returnConfirmationObjectMutation", { 
                id: this.selectedReferential, 
                type: "referential-change-status",
                title: title,
                message: message,
                newStatus: status,
                status: this.releaseStatus,
            })
            //console.log(`Demande de changement de statut de '${this.releaseStatus}' vers '${status}'`)
        },

        /* async handleReferentialClick(id) {
            ////console.log("locked_", this.getReferentialStatus(id))
            if (this.loading) return;
        
            try {
                this.$store.commit("referential/loadingMutation", true);
            
                if (this.selectedReferential === id) {
                    this.exitReferentialView();
                } else {
                    await this.$store.dispatch("referential/fetchCriteriaListFromReferential", { id: id});
                    this.$store.commit("referential/selectTreeMutation", id);
                    this.$router.push('/referential/'+id);
                }
            } catch (error) {
                console.error("Error handling referential click:", error);
            } finally {
                this.$store.commit("referential/loadingMutation", false);
            }
        }, */
        resetFilters() {
            this.filters.title = "";
            this.filters.status = "";
            this.sortField = "id";
            this.sortDirection = "asc";
            this.$router.push('/referential');
        },
        /* exitReferentialView() {
            this.$store.commit("referential/selectTreeMutation", 0)
            this.$router.push('/referential')
            this.resetFilters();
        }, */
        createReferentialModalOpen() {
            if(this.selectedReferential == 0) {
                this.$store.commit("referential/toggleReferenentialModalNew", true)
            } 
        },
        createReferentialModalClose() {
            if(this.selectedReferential == 0) {
                this.$store.commit("referential/toggleReferenentialModalNew", false)
            }
        },
        editReferential() {
            this.$store.commit("referential/toggleReferenentialModalNew", true)
        },
        addChild() {
            let rootCriteria = this.fetchRootCriteria(this.selectedReferential)
            //console.log("rootCriteria : ",rootCriteria)
            this.$store.commit("referential/makeCriteriaActiveMutation", [])
            this.$store.commit("referential/callerSetMutation", rootCriteria)
            this.toggleCriteriaModalOpen()
        },
        toggleCriteriaModalOpen() {
            if (this.selectedReferential > 0) {
                this.$store.commit("referential/toggleCriteriaModal", !this.canEditList.criteriaEditorOpen)
            } else {
                this.$store.commit("referential/toggleCriteriaModal", false)
            }
        },
        deleteReferentialTemp(referential) {
            //console.log("Vous avez appuyer sur le bouton delete")
            //const refId = referential.referentiel_id ? referential.referentiel_id : this.selectedReferential;
            //console.log("ID referentiel suppression ", referential);
            //console.log("Statut referentiel suppression ", this.projectStatusByReferential[refId]);
            let hasBlockingError = false;
            if(this.projectStatusByReferential[referential.referentiel_id].length>0){
                //console.log(this.projectStatusByReferential)
                hasBlockingError = true;
                this.$store.commit("referential/returnConfirmationObjectMutation", { 
                    id: this.selectedReferential, 
                    type: "delete-referential",
                    title: "Suppression",
                    message: "Vous ne pouvez pas supprimer ce référentiel.\nUn(des) projet(s) y sont encore liés.\nVeuillez les supprimer avant de réessayer",
                    hasBlockingError: hasBlockingError  
                })    
            }else{
                this.$store.commit("referential/returnConfirmationObjectMutation", { 
                    id: this.selectedReferential, 
                    type: "delete-referential",
                    title: "Suppression",
                    message: "Êtes-vous sûr de vouloir supprimer ce référentiel?"
                })    
            }
        },
        /* deleteReferential() {
            //console.log("Statut referentiel suppression ",this.getProjectsInValidation, "\n",this.getProjectsAfterValidation);
            this.$store.commit("referential/returnConfirmationObjectMutation", { 
                id: this.selectedReferential, 
                type: "delete-referential",
                title: "Suppression",
                message: "Êtes-vous sûr de vouloir supprimer ce référentiel?"
            })
        }, */
        
        async duplicateReferential() {
            this.$store.commit("referential/returnConfirmationObjectMutation", { 
                id: this.selectedReferential, 
                type: "duplicate-referential",
                title: "Duplication",
                message: "Êtes-vous sûr de vouloir dupliquer ce référentiel?"
            })
        },
        async analyzeReferential(){
            await this.$store.dispatch("referential/referentialValidate", {
                id: this.selectedReferential
            })
            let title = ""
            let message = ""
            const hasBlockingError = this.referentialErrors.some(error => error.status === 'ERREUR');
            const hasErrors = this.referentialErrors && this.referentialErrors.length > 0;
            title = "Analyse";
                    if(hasErrors){
                            message = "Le référentiel a des problèmes :<br><br>";
                            for (const error of this.referentialErrors){
                                message += `<b>Status:</b> ${error.status}<br>`;
                                message += `<b class="parameters">Paramètre:</b> ${error.parameter}<br>`;
                                message += `<b>Message:</b> ${error.message}<br><br>`;
                            }
                    }else{
                            message = "Aucun problème/information sur ce référentiel"
                        }
                this.$store.commit("referential/returnConfirmationObjectMutation", { 
                id: this.selectedReferential, 
                type: "referential-analyze-status",
                title: title,
                message: message,
                hasBlockingError: hasBlockingError,
                //newStatus: status,
            })
        },
       
        getStatusLabel(referential) {
            let status = referential.status
            if (!this.statusOptions || this.statusOptions.length === 0) {
                return status;
            }
            // //console.log("projectsAfterValidation", projectsAfterValidation)
            // //console.log("referential in getStatusLabel", referential.referentiel_id, referential.status)
            ////console.log("this status projects", this.getProjectsAfterValidationList[referential.referentiel_id])
            /* if(status === "RELEASE" && this.getProjectsAfterValidationList[referential.referentiel_id]?.length > 0) {
                status = "RELEASEUSED"
            } */
            const optionValue = this.statusOptions.find(opt => opt.value === status);
            return optionValue ? optionValue.label : status;
        },
        createProject() {
            this.$store.commit("referential/toggleProjectCreatorModal", { 
                open: true,
                referential_id: this.selectedReferential,
             })
            //console.log("Creating project from referential", this.canEditList)
            // this.$store.commit("project/setReferentialId", this.selectedReferential)
        },
        unlockReferential() {
            if (this.getReferentialStatus(this.selectedReferential).LOCKED && this.getReferentialStatus(this.selectedReferential).OWNER) {
                this.$store.commit("referential/returnConfirmationObjectMutation", { 
                    id: this.selectedReferential, 
                    type: "unlock-referential",
                    title: "Déverrouillage",
                    message: "Êtes-vous sûr de vouloir déverrouiller ce référentiel?"
                })
            } else {
                console.warn("Cannot unlock referential, not locked or not owner")
            }
        },
        exitReferentialView() {
            this.$store.commit("referential/selectTreeMutation", 0)
            this.$router.push('/referential')
            this.filters.title = "";
            this.filters.status = "";
            this.sortField = "id";
            this.sortDirection = "asc";
        },
        /* canEditReferential(referentialId) {
            const status = this.getReferentialStatus(referentialId);
            if(status.READONLY) {
                return false
            }
            if(!status.LOCKED) {
                return true // If not locked, always editable
            }
            return status.OWNER && status.LOCKED // If locked, must be owner to edit
        }, */
        referentialStatus(referentialId){
            /* if(!referentialId === this.getReferentialStatus(referentialId)) {
                return {"LOCKED": false, "OWNER": false, "READONLY": false, "EDITOR": false};
            }else { */
                return this.getReferentialStatus(referentialId);
            /* } */
        },
        goToProjectValidators() {
            this.$router.push(`/referential/${this.selectedReferential}/projects/access`);
            //console.log("Going to referential/:id/projects/access")
        },
    },
};
</script>

<style scoped>

 
.referential-item:has(.actions-col) {
    grid-template-columns:28% 45% 27%;
    border: 2px solid white;
    transition: all 0.2s ease;
    background-color: var(--bg-color);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}


@media only screen and (min-width: 768px) and (max-width: 1400px) {
    .referential-item:has(.actions-col) {
        grid-template-columns: 26% 34% 40%;
    }
}

/* .referential-item:has(.projects-col) {
    grid-template-columns:28% 42% 10% 20%;
}

*/
.referential-item:hover:has(.actions-col){
    background-color: var(--bg-color);
}


.projects-name {
    text-decoration: underline;
    font-weight: 700;

}

.referential-list:has(.actions-col){
    background-color: var(--bg-color);
}

.referential-item {
    padding: 15px 3vw;
    border: 2px solid #e9ecef;
    /* border-radius: 12px; */

    cursor: pointer;
    /* margin-bottom: 12px; */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    position: relative;
    overflow: hidden;
    background-color: var(--bg-color);

    display: grid;
    grid-template-columns: 22% 30% 14% 18% 17%;
    width: 100%;
    align-items: center;
}

.referential-item:hover {
    background-color: var(--hover-bg);
    /* transition: border 0.2s linear; */
    transition: color 0.2s linear;
    border-top: 2px solid var(--primary-color);
    border-bottom: 2px solid var(--primary-color);
    transition: border 0.27s ease-in;
}


/* buttons */

.btn {
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: 500;
}

.btn-icon {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 18px;
    padding: 0;
    margin: 0 2px;
    background-color: var(--hover-bg);
    color: var(--text-color);
}

.btn-icon:hover {
    color: var(--primary-color);
}

.actions-col {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 3vw;
    gap: 2px;
}

.referential-item.locked {
    /* cursor: not-allowed; */
    opacity: 0.65;
}

</style>